<fieldset class="relative flex flex-col border border-outline bg-white rounded-1 py-1 pb-2.5 px-1">
    <legend class="text-xs ms-3 select-none">{{ data().label }}</legend>
    @if (data().hasSelectAll) {
   <cac-checkbox [control]="selectAllControl">همه</cac-checkbox>
    }
    @for (item of data().items; track $index) {
    <cac-checkbox [control]="item.control" (onChange)="updateSelectAll()">{{item.label }}</cac-checkbox>
    }
</fieldset>